import { EventRequest, EventStatus } from '../../../interfaces/events';
import { Balance } from '../../../interfaces/strapiComponents/balance';

const costRows: { key: keyof Omit<Balance, 'id'>; label: string }[] = [
  { key: 'wines', label: 'Acquisto vini' },
  { key: 'food', label: 'Cibo' },
  { key: 'rooms', label: 'Costo sala' },
  { key: 'sponsorship', label: 'Spese per promozione evento' },
  { key: 'teacherPayments', label: 'Eventuali compensi relatori da saldare' },
  { key: 'teacherRefunds', label: 'Eventuali rimborsi relatori da saldare' },
  { key: 'couponsExpenses', label: 'Spese totali per coupon' },
  { key: 'discountExpenses', label: 'Spese totali per sconti' },
  { key: 'sectionVariousExpenses', label: 'Spese varie di Sezione' },
  { key: 'extras', label: 'Extra - Eventuali costi non preventivabili' },
];

export const getZeroCostWarning = (
  event: Pick<EventRequest, 'balance' | 'headquarterBalance'>,
  status?: EventStatus,
  includeHeadquarterCosts = false,
) => {
  const isPublishing = status === EventStatus.PUBLISHED;
  const isReporting =
    status === EventStatus.FINAL_BALANCE_DELEGATION ||
    status === EventStatus.FINAL_BALANCE_NATIONAL;

  if (!isPublishing && !isReporting) return undefined;

  const field = isPublishing ? 'estimatedOutflow' : 'finalOutflow';
  const labels = costRows
    // La tabella non prevede costi consuntivi per i coupon.
    .filter(({ key }) => isPublishing || key !== 'couponsExpenses')
    .filter(({ key }) => Number(event.balance?.[key]?.[field] ?? 0) === 0)
    .map(({ label }) => label);

  if (
    includeHeadquarterCosts &&
    Number(event.headquarterBalance?.teachingMaterial?.[field] ?? 0) === 0
  ) {
    labels.push('Costo materiale didattico (spese della sede)');
  }

  if (!labels.length) return undefined;

  return {
    labels,
    action: isPublishing ? 'pubblicazione' : 'rendicontazione',
  };
};
